import React, {useEffect} from 'react'
import { useHistory } from "react-router-dom";
import {
    Box,
    Grid,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    IconButton,
    Typography,
    Collapse,
    ListItem,
    Card,
    CardContent,
    CardActionArea,
    Container,
    Paper,
    Skeleton,
    Alert
} from "@mui/material";
import { getDashboardSummary, getInventoryExpiry } from "../../utilityFunctions/WarehouseUtil";
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Colors from "../../components/ui/Colors";
import { ClientRol } from '../admin';
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import styled from '@emotion/styled';

// Menu Category Icons
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BuildIcon from '@mui/icons-material/Build';
import SecurityIcon from '@mui/icons-material/Security';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// Menu Item Icons
import AddTaskIcon from '@mui/icons-material/AddTask';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DownloadIcon from '@mui/icons-material/Download';
import BarChartIcon from '@mui/icons-material/BarChart';
import InventoryIcon from '@mui/icons-material/Inventory';
import WarningIcon from '@mui/icons-material/Warning';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HistoryIcon from '@mui/icons-material/History';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddBoxIcon from '@mui/icons-material/AddBox';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StorageIcon from '@mui/icons-material/Storage';


const nutrion = true;

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

// Styled Components
const RoleHeader = styled(Typography)(({ theme }) => ({
    color: Colors.primary,
    padding: '16px 16px 8px 16px',
    fontWeight: 700,
    fontSize: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: `2px solid ${Colors.primary}`,
    marginBottom: '16px'
}));

const CategoryHeader = styled(Typography)(({ theme }) => ({
    color: Colors.primary,
    padding: '16px 16px 8px 16px',
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px'
}));

const MenuItemButton = styled(ListItemButton)(({ theme }) => ({
    padding: '8px 16px 8px 32px',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& .MuiListItemIcon-root': {
        minWidth: '40px',
        color: Colors.primary
    }
}));

const HeroSection = styled(Box)(({ theme }) => ({
    background: `linear-gradient(135deg, ${Colors.primary}15 0%, ${Colors.primary}05 100%)`,
    padding: theme.spacing(2, 2),
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(2)
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
    color: Colors.primary,
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: '1.5rem'
}));

const ActionCard = styled(Card)(({ theme }) => ({
    height: '100%',
    borderRadius: theme.spacing(3),
    boxShadow: theme.shadows[6],
    transition: 'transform 0.2s, box-shadow 0.2s',
    backgroundColor: 'background.paper',
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: theme.shadows[8],
        backgroundColor: `${Colors.primary}05`
    }
}));

const CardIcon = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    '& svg': {
        fontSize: '3rem',
        color: Colors.primary
    }
}));

const LogoImage = styled('img')(({ theme }) => ({
    height: 'auto',
    width: '180px',
    marginLeft: theme.spacing(4)
}));

const ImageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%'
}));

let openAdmin=false;
let openWarehouse=false;
let openInfoSecurity=false;
let openSupervisorLimited=false;

export default function HanldeProfile(props) {
    const {
        loginUser, loadProductsAndSetting, updateDealsDefinitions, updateDealsList, warehouseProducts, getWarehouseProducts
    } = props

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);
    const [summary, setSummary] = React.useState(null);
    const [summaryLoading, setSummaryLoading] = React.useState(true);
    const [inventoryExpiry, setInventoryExpiry] = React.useState(null);

    useEffect(() => {
        handleAdmin();
        updateWarehouseProducts();
        const isDashboardRole = loginUser.roles?.some(r =>
            r.authority === "ADMIN" || r.authority === "SUPERVISOR" || r.authority === "SUPERVISORLIMITED"
        );
        if (isDashboardRole) fetchDashboard();
    }, []);

    const fetchDashboard = async () => {
        setSummaryLoading(true);
        const [summaryRes, expiryRes] = await Promise.all([
            getDashboardSummary(loginUser.jwtToken),
            getInventoryExpiry(loginUser.jwtToken),
        ]);
        if (summaryRes) setSummary(summaryRes);
        if (expiryRes) setInventoryExpiry(expiryRes);
        setSummaryLoading(false);
    };

    const updateWarehouseProducts = async () => {
        if(warehouseProducts){
            return;
        }

        await getWarehouseProducts(loginUser.jwtToken);

    }

    const [profileOptions, setProfileOptions] = React.useState("");

  
    const createQrLabel = () => {
        history.push({pathname: "/warehouse/batch-label"});
    };
    const gotToCheckpoint = () => {
        history.push({pathname: "/warehouse/checkpoint"});
    };
    const gotToBatches = () => {
        history.push({pathname: "/warehouse/batches"});
    };
    const gotToWarehouse = () => {
        history.push({pathname: "/warehouse/structure"});
    };
    const gotToInventory = () => {
        history.push({pathname: "/warehouse/inventory"});
    };
    const gotToDurations = () => {
        history.push({pathname: "/warehouse/durations"});
    };
    const gotToDeliveryCharts = () => {
        history.push({pathname: "/warehouse/delivery-charts"});
    };
    const gotTobatchChanges = () => {
        history.push({pathname: "/warehouse/batch-changes"});
    };
    const gotTobatchChangesReport = () => {
        history.push({pathname: "/warehouse/batch-changes-report"});
    };
    const goToCreateOrders = () => {
        history.push({pathname: "/warehouse/create-orders"});
    };
    const goToActiveOrders = () => {
        history.push({pathname: "/warehouse/active-orders"});
    };
    const goToPendingOrders = () => {
        history.push({pathname: "/warehouse/pending-order"});
    };
    const goToTransportOrders = () => {
        history.push({pathname: "/warehouse/transport-orders-list"});
    };
    const goToCediOrders = () => {
        history.push({pathname: "/warehouse/cedi-orders-list"});
    };
    const goToNewCediOrder = () => {
        history.push({pathname: "/warehouse/new-cedi-order"});
    };
    const goToNewWhProduct = () => {
        history.push({pathname: "/warehouse/new-product"});
    };
    const goToCsvWarehouse = () => {
        history.push({pathname: "/warehouse/csv-reports"});
    };
    const goToNewUser = () => {
        history.push({pathname: "/auth/new-user"});
    };
    const goToBatchDefectsReport = () => {
        history.push({pathname: "/warehouse/batch-defects-report"});
    };
    const goToPickingOrdersReport = () => {
        history.push({pathname: "/warehouse/picking-orders-report"});
    };

    const goToManageUsers = () => {
        history.push({pathname: "/security/users-management"});
    };

    const goToChangePickingStatus = () => {
        history.push({pathname: "/warehouse/picking-order"});
    };
    
    const goToManualInventory = () => {
        history.push({pathname: "/warehouse/manual-inventory"});
    };
    
    const goToManualInventoryList = () => {
        history.push({pathname: "/warehouse/manual-inventory-list"});
    };

    const goToCreateBatchDefects = () => {
        history.push({pathname: "/warehouse/create-batch-defects"});
    };
    
    
    const profileOptionsDrawer = (userRole) => {
        const menuCategories = {
            orders: {
                title: "Órdenes de Clientes",
                icon: <AssignmentIcon />,
                items: [
                    { text: "Cargar Órdenes", icon: <AddTaskIcon />, action: goToCreateOrders },
                    { text: "Órdenes Pendientes", icon: <PendingActionsIcon />, action: goToPendingOrders },
                    { text: "Órdenes Despacho", icon: <LocalShippingIcon />, action: goToTransportOrders }
                ]
            },
            reports: {
                title: "Reportes",
                icon: <AssessmentIcon />,
                items: [
                    { text: "Descarga Reportes", icon: <DownloadIcon />, action: goToCsvWarehouse },
                    { text: "Métricas", icon: <BarChartIcon />, action: gotToDeliveryCharts },
                    { text: "Estibas", icon: <InventoryIcon />, action: () => gotToBatches("one") },
                    { text: "Reporte Averías", icon: <WarningIcon />, action: goToBatchDefectsReport },
                    { text: "Reporte Picking", icon: <AssignmentTurnedInIcon />, action: goToPickingOrdersReport },
                    { text: "Reporte Cambios", icon: <HistoryIcon />, action: gotTobatchChangesReport },
                    { text: "Tiempos", icon: <AccessTimeIcon />, action: gotToDurations }
                ]
            },
            processes: {
                title: "Procesos",
                icon: <BuildIcon />,
                items: [
                    // { text: "Checkpoint", icon: <CheckCircleIcon />, action: () => gotToCheckpoint("one") },
                    { text: "Creación QR", icon: <QrCodeIcon />, action: createQrLabel },
                    { text: "Inventario", icon: <StorageIcon />, action: gotToInventory },
                    { text: "Nuevo Inventario Manual", icon: <AddBoxIcon />, action: goToManualInventory },
                    { text: "Inventarios Manuales", icon: <InventoryIcon />, action: goToManualInventoryList },
                    { text: "Cambio Estiba", icon: <SwapHorizIcon />, action: gotTobatchChanges },
                    { text: "Creación Averías", icon: <WarningIcon />, action: goToCreateBatchDefects },
                    { text: "Asignación Picking", icon: <AssignmentTurnedInIcon />, action: () => goToChangePickingStatus("one") }
                ]
            },
            create: {
                title: "Crear",
                icon: <AddCircleIcon />,
                items: [
                    { text: "Creación Usuario", icon: <PersonAddIcon />, action: () => goToNewUser("one") },
                    { text: "Creación Producto", icon: <AddBoxIcon />, action: () => goToNewWhProduct("one") }
                ]
            },
            others: {
                title: "Otros",
                icon: <MoreHorizIcon />,
                items: [
                    { text: "Bodega", icon: <WarehouseIcon />, action: () => gotToWarehouse("one") },
                    { text: "Órdenes Cedi", icon: <LocalConvenienceStoreIcon />, action: goToCediOrders }
                ]
            }
        };

        const renderMenuSection = (category) => (
            <React.Fragment key={category.title}>
                <CategoryHeader>
                    {category.icon}
                    {category.title}
                </CategoryHeader>
                {category.items.map((item) => (
                    <MenuItemButton
                        key={item.text}
                        onClick={item.action}
                    >
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText 
                            primary={item.text}
                            primaryTypographyProps={{
                                variant: "body2",
                                color: "text.primary"
                            }}
                        />
                    </MenuItemButton>
                ))}
            </React.Fragment>
        );

        const getRoleTitle = () => {
            switch(userRole) {
                case "ADMIN": return "ADMINISTRADOR";
                case "SUPERVISOR": return "SUPERVISOR";
                case "PROD": return "PRODUCCIÓN";
                case "TRANSPORTER": return "MONTACARGAS";
                case "SECURITY": return "SEGURIDAD";
                case "SUPERVISORLIMITED": return "SUPERVISOR NOCHE";
                default: return "";
            }
        };

        const getRoleMenuItems = () => {
            switch(userRole) {
                case "ADMIN":
                    return Object.values(menuCategories);
                case "SUPERVISOR":
                    return [
                        menuCategories.orders,
                        {
                            title: "Reportes",
                            icon: <AssessmentIcon />,
                            items: [
                                { text: "Reporte Averías", icon: <WarningIcon />, action: goToBatchDefectsReport },
                                { text: "Reporte Picking", icon: <AssignmentTurnedInIcon />, action: goToPickingOrdersReport },
                                { text: "Reporte Cambios", icon: <HistoryIcon />, action: gotTobatchChangesReport },
                                { text: "Descarga Reportes", icon: <DownloadIcon />, action: goToCsvWarehouse },
                                { text: "Estibas", icon: <InventoryIcon />, action: () => gotToBatches("one") }
                            ]
                        },
                        {
                            title: "Procesos",
                            icon: <BuildIcon />,
                            items: [
                                { text: "Checkpoint", icon: <CheckCircleIcon />, action: () => gotToCheckpoint("one") },
                                { text: "Creación QR", icon: <QrCodeIcon />, action: createQrLabel },
                                { text: "Inventario", icon: <StorageIcon />, action: gotToInventory },
                                { text: "Nuevo Inventario Manual", icon: <AddBoxIcon />, action: goToManualInventory },
                                { text: "Inventarios Manuales", icon: <InventoryIcon />, action: goToManualInventoryList },
                                { text: "Asignación Picking", icon: <AssignmentTurnedInIcon />, action: () => goToChangePickingStatus("one") },
                                { text: "Cambio Estiba", icon: <SwapHorizIcon />, action: gotTobatchChanges },
                                { text: "Creación Averías", icon: <WarningIcon />, action: goToCreateBatchDefects }
                            ]
                        },
                        menuCategories.others
                    ];
                case "PROD":
                    return [{
                        title: "Procesos",
                        icon: <BuildIcon />,
                        items: [
                            { text: "Creación QR", icon: <QrCodeIcon />, action: createQrLabel }
                        ]
                    }];
                case "TRANSPORTER":
                    return [{
                        title: "Procesos",
                        icon: <BuildIcon />,
                        items: [
                            { text: "Creación QR", icon: <QrCodeIcon />, action: createQrLabel },
                            { text: "Checkpoint", icon: <CheckCircleIcon />, action: () => gotToCheckpoint("one") },
                            { text: "Bodega", icon: <WarehouseIcon />, action: () => gotToWarehouse("one") }
                        ]
                    }];
                case "SECURITY":
                    return [{
                        title: "Usuarios",
                        icon: <PersonAddIcon />,
                        items: [
                            { text: "Creación Usuario", icon: <PersonAddIcon />, action: () => goToNewUser("one") },
                            { text: "Gestión de Usuarios", icon: <AssignmentTurnedInIcon />, action: goToManageUsers }
                        ]
                    }];
                case "SUPERVISORLIMITED":
                    return [
                        {
                            title: "Procesos",
                            icon: <BuildIcon />,
                            items: [
                                { text: "Checkpoint", icon: <CheckCircleIcon />, action: () => gotToCheckpoint("one") },
                                { text: "Cambio Estiba", icon: <SwapHorizIcon />, action: gotTobatchChanges },
                                { text: "Asignación Picking", icon: <AssignmentTurnedInIcon />, action: () => goToChangePickingStatus("one") },
                                { text: "Creación Averías", icon: <WarningIcon />, action: goToCreateBatchDefects }
                            ]
                        },
                        {
                            title: "Órdenes de Clientes",
                            icon: <AssignmentIcon />,
                            items: [
                                { text: "Órdenes Despacho", icon: <LocalShippingIcon />, action: goToTransportOrders }
                            ]
                        },
                    ];
                default:
                    return [];
            }
        };

        setProfileOptions(
            <List sx={{ width: "100%" }}>
                <RoleHeader>{getRoleTitle()}</RoleHeader>
                {getRoleMenuItems().map(renderMenuSection)}
            </List>
        );
    };

    

    const handleExpand = () => {
        openAdmin=!openAdmin;
        handleAdmin(); 
    };

    const handleExpandWarehouse = () => {
        openWarehouse=!openWarehouse;
        handleAdmin(); 
    };

    const handleExpandInfoSecurity = () => {
        openInfoSecurity=!openInfoSecurity;
        handleAdmin(); 
    };

    const handleExpandSupervisorLimited = () => {
        openSupervisorLimited=!openSupervisorLimited;
        handleAdmin(); 
    };


    
    
    const handleAdmin = () => {
        if(loginUser.roles && !(Object.keys(loginUser.roles).length === 0 && loginUser.roles.constructor === Object)){
            if(loginUser.roles.some((rol) => rol.authority === "ADMIN")){
                profileOptionsDrawer("ADMIN");
            }
            else if(loginUser.roles.some((rol) => rol.authority === "PROD")){
                profileOptionsDrawer("PROD");
            }
            else if(loginUser.roles.some((rol) => rol.authority === "SUPERVISOR")){
                profileOptionsDrawer("SUPERVISOR");
            }
            else if(loginUser.roles.some((rol) => rol.authority === "TRANSPORTER")){
                profileOptionsDrawer("TRANSPORTER");
            }
            else if(loginUser.roles.some((rol) => rol.authority === "SECURITY")){
                profileOptionsDrawer("SECURITY");
            }
            else if(loginUser.roles.some((rol) => rol.authority === "SUPERVISORLIMITED")){
                profileOptionsDrawer("SUPERVISORLIMITED");
            }
            else {
                profileOptionsDrawer(false);
            }
        }
    };

    const getRoleSpecificActions = () => {
        if (!loginUser.roles) return [];

        const isAdmin = loginUser.roles.some(rol => rol.authority === "ADMIN");
        const isSupervisor = loginUser.roles.some(rol => rol.authority === "SUPERVISOR");
        const isProd = loginUser.roles.some(rol => rol.authority === "PROD");
        const isTransporter = loginUser.roles.some(rol => rol.authority === "TRANSPORTER");
        const isSecurity = loginUser.roles.some(rol => rol.authority === "SECURITY");
        const isSupervisorLimited = loginUser.roles.some(rol => rol.authority === "SUPERVISORLIMITED");

        if (isAdmin) {
            return [
                {
                    title: "Órdenes de Despacho",
                    description: "Gestiona y monitorea las órdenes de despacho",
                    icon: <LocalShippingIcon />,
                    action: goToTransportOrders
                },
                {
                    title: "Métricas",
                    description: "Visualiza estadísticas del proceso",
                    icon: <AssessmentIcon />,
                    action: gotToDeliveryCharts
                },                    
            ];
        } else if (isSupervisor) {
            return [
                {
                    title: "Órdenes de Despacho",
                    description: "Gestiona y monitorea las órdenes de despacho",
                    icon: <LocalShippingIcon />,
                    action: goToTransportOrders
                },
                {
                    title: "Checkpoint",
                    description: "Gestiona el checkpoint del producto",
                    icon: <CheckCircleIcon />,
                    action: () => gotToCheckpoint("one")
                }
            ];
        } else if (isProd) {
            return [
                {
                    title: "Creación QR",
                    description: "Genera códigos QR",
                    icon: <QrCodeIcon />,
                    action: createQrLabel
                }
            ];
        } else if (isTransporter) {
            return [
                {
                    title: "Checkpoint",
                    description: "Gestiona el checkpoint del producto",
                    icon: <CheckCircleIcon />,
                    action: () => gotToCheckpoint("one")
                },
            ];
        } else if (isSecurity) {
            return [
                {
                    title: "Gestión de Usuarios",
                    description: "Administra usuarios del sistema",
                    icon: <PersonAddIcon />,
                    action: goToManageUsers
                }
            ];
        } else if (isSupervisorLimited) {
            return [
                {
                    title: "Checkpoint",
                    description: "Gestiona el checkpoint del producto",
                    icon: <CheckCircleIcon />,
                    action: () => gotToCheckpoint("one")
                },
                {
                    title: "Cambios de Estiba",
                    description: "Gestiona cambios de estiba",
                    icon: <SwapHorizIcon />,
                    action: gotTobatchChanges
                }
            ];
        }

        return [];
    };

    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };

    // ── Role flags ─────────────────────────────────────────────────────────────
    const isAdmin = loginUser.roles?.some(r => r.authority === "ADMIN");
    const isSupervisor = loginUser.roles?.some(r => r.authority === "SUPERVISOR");
    const isSupervisorLimited = loginUser.roles?.some(r => r.authority === "SUPERVISORLIMITED");
    const showDashboard = isAdmin || isSupervisor || isSupervisorLimited;

    // ── Helpers ─────────────────────────────────────────────────────────────────
    const numFmt = (n) => {
        if (!n && n !== 0) return '—';
        if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
        if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
        return new Intl.NumberFormat('es-CO').format(Math.round(n));
    };
    const numFull = (n) => new Intl.NumberFormat('es-CO').format(Math.round(n || 0));

    const HomeKpiCard = ({ label, value, sub, color, loading: cardLoading }) => (
        <Paper elevation={0} sx={{
            p: { xs: 1.5, sm: 2 },
            borderRadius: 2,
            border: '1px solid #d1d9e6',
            borderLeft: `4px solid ${color || Colors.primary}`,
            backgroundColor: '#fff',
            height: '100%',
        }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block' }}>
                {label}
            </Typography>
            {cardLoading ? (
                <Skeleton variant="text" width="60%" height={32} />
            ) : (
                <Typography variant="h6" sx={{ fontWeight: 'bold', color, lineHeight: 1.2 }}>
                    {value}
                </Typography>
            )}
            {sub && <Typography variant="caption" sx={{ color: 'text.secondary' }}>{sub}</Typography>}
        </Paper>
    );

    const getLandingQuickActions = () => {
        if (isAdmin) return [
            { title: "Órdenes de Despacho", description: "Ver y gestionar viajes", icon: <LocalShippingIcon />, action: goToTransportOrders },
            { title: "Checkpoint", description: "Escanear estibas", icon: <CheckCircleIcon />, action: gotToCheckpoint },
            { title: "Métricas", description: "Estadísticas completas", icon: <BarChartIcon />, action: gotToDeliveryCharts },
            { title: "Estibas", description: "Registro de estibas", icon: <InventoryIcon />, action: gotToBatches },
        ];
        if (isSupervisor) return [
            { title: "Checkpoint", description: "Escanear estibas", icon: <CheckCircleIcon />, action: gotToCheckpoint },
            { title: "Órdenes de Despacho", description: "Ver viajes activos", icon: <LocalShippingIcon />, action: goToTransportOrders },
            { title: "Estibas", description: "Registro de estibas", icon: <InventoryIcon />, action: gotToBatches },
        ];
        if (isSupervisorLimited) return [
            { title: "Checkpoint", description: "Escanear estibas", icon: <CheckCircleIcon />, action: gotToCheckpoint },
            { title: "Estibas", description: "Ver estibas", icon: <InventoryIcon />, action: gotToBatches },
        ];
        return [];
    };

  return (
      <React.Fragment>
        {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
            <Box sx={{ 
                position: 'absolute',
                top: "5rem",
                left: 0,
                right: 0,
                bottom: 0,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Grid container sx={{ flex: 1, overflow: 'hidden' }}>
                    <Grid item xs={2} sm={4} md={3} lg={3} sx={{paddingLeft: "1rem"}}>
                        <Box 
                            sx={{
                                position: 'fixed',
                                top: '5rem',
                                left: '2.5rem',
                                zIndex: 1200,
                                display: { xs: 'block', sm: 'block', md: 'none' }
                            }}
                        >
                            <IconButton
                                onClick={handleDrawerToggle}
                                sx={{ 
                                    color: Colors.primary,
                                    backgroundColor: 'white',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)'
                                    }
                                }}
                                size="large"
                            >
                                <MenuIcon sx={{ fontSize: 28 }} />
                            </IconButton>
                        </Box>
                        <Drawer
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                display: { xs: 'block', sm: 'block', md: "none" },
                                '& .MuiDrawer-paper': { 
                                    boxSizing: 'border-box',
                                    width: {xs: "80%", sm: "35%"},
                                    marginTop: "5rem",
                                    height: "calc(100% - 5rem)",
                                    backgroundColor: 'background.paper',
                                    boxShadow: 3,
                                    overflowY: 'auto'
                                }
                            }}
                        >
                            {profileOptions}
                        </Drawer>
                        <Box sx={{marginTop: "5rem"}}>
                            <Drawer
                                variant="permanent"
                                sx={{
                                    display: { xs: 'none', sm: 'none', md: 'flex'},
                                    '& .MuiDrawer-paper': { 
                                        boxSizing: 'border-box',
                                        width: "20%",
                                        marginTop: "5rem",
                                        height: "calc(100vh - 5rem)",
                                        overflowY: 'auto',
                                        backgroundColor: 'background.paper',
                                        boxShadow: 2,
                                        position: 'fixed'
                                    }
                                }}
                                open
                            >
                                {profileOptions}
                            </Drawer>
                        </Box>
                    </Grid>
                    {nutrion === false ? (
                        <Grid item xs={10} sm={8} md={9} lg={9} sx={{ 
                            mt: '5rem', 
                            height: 'calc(100vh - 5rem)',
                            overflow: 'auto',
                            flex: 1
                        }}>
                            <ClientRol {...props}/>
                        </Grid>
                    ) : (
                        <Grid item xs={10} sm={8} md={9} lg={9} sx={{
                            mt: '0rem',
                            height: 'calc(100vh - 5rem)',
                            overflow: 'auto',
                            flex: 1
                        }}>
                            {showDashboard ? (
                                /* ── Dashboard landing (Admin / Supervisor / SupervisorLimited) ── */
                                <Box sx={{ backgroundColor: '#f0f4f8', minHeight: '100%', py: { xs: 2, sm: 3 }, px: { xs: 1.5, sm: 3 } }}>

                                    {/* Header */}
                                    <Box sx={{ backgroundColor: Colors.primary, borderRadius: 2, px: 2.5, py: 2, mb: 2.5 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fff' }}>
                                            Bienvenido
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.65)' }}>
                                            Nutrion · Producto Terminado
                                        </Typography>
                                    </Box>

                                    {/* KPI Cards */}
                                    <Grid container spacing={2} sx={{ mb: 2 }}>
                                        <Grid item xs={6} sm={isAdmin ? 4 : 6} md={isAdmin ? 2 : 4}>
                                            <HomeKpiCard label="Viajes activos" value={numFull(summary?.activeTransportOrders)} sub="En curso ahora" color="#1c2444" loading={summaryLoading} />
                                        </Grid>
                                        <Grid item xs={6} sm={isAdmin ? 4 : 6} md={isAdmin ? 2 : 4}>
                                            <HomeKpiCard label="Pedidos pendientes" value={numFull(summary?.pendingDeliveryOrders)} sub="Sin despachar" color="#0891b2" loading={summaryLoading} />
                                        </Grid>
                                        {isAdmin && (
                                            <>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <HomeKpiCard label="Estibas en bodega" value={numFull(summary?.batchesInWarehouse)} sub="Activas" color="#1e40af" loading={summaryLoading} />
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <HomeKpiCard label="Unidades en bodega" value={numFmt(summary?.unitsInWarehouse)} sub="Stock actual" color="#2563eb" loading={summaryLoading} />
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <HomeKpiCard label="Averías totales" value={numFmt(summary?.totalDefectUnits)} sub="Acumuladas" color="#ef4444" loading={summaryLoading} />
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <HomeKpiCard
                                                        label="Ciclo promedio"
                                                        value={summary?.avgCycleDays != null ? `${summary.avgCycleDays.toFixed(1)} días` : '—'}
                                                        sub="Entrada a salida"
                                                        color="#0284c7"
                                                        loading={summaryLoading}
                                                    />
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>

                                    {/* Alerts */}
                                    {!summaryLoading && inventoryExpiry?.expiredCount > 0 && (
                                        <Alert severity="error" sx={{ mb: 1.5, borderRadius: 2 }}>
                                            <strong>{inventoryExpiry.expiredCount}</strong> estiba(s) con producto <strong>vencido</strong> en bodega
                                        </Alert>
                                    )}
                                    {!summaryLoading && inventoryExpiry?.expiring30Count > 0 && (
                                        <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 2 }}>
                                            <strong>{inventoryExpiry.expiring30Count}</strong> estiba(s) vence(n) en menos de 30 días
                                        </Alert>
                                    )}
                                    {!summaryLoading && summary?.pendingDeliveryOrders > 0 && (
                                        <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
                                            Hay <strong>{numFull(summary.pendingDeliveryOrders)}</strong> pedido(s) pendiente(s) de despacho
                                        </Alert>
                                    )}

                                    {/* Quick actions */}
                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1.5 }}>
                                        Acciones rápidas
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {getLandingQuickActions().map((action, i) => (
                                            <Grid item xs={6} sm={4} md={3} key={i}>
                                                <Paper
                                                    elevation={0}
                                                    onClick={action.action}
                                                    sx={{
                                                        border: '1px solid #d1d9e6',
                                                        borderLeft: `4px solid ${Colors.primary}`,
                                                        borderRadius: 2,
                                                        backgroundColor: '#fff',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.15s',
                                                        '&:hover': { backgroundColor: '#e8edf5', transform: 'translateY(-2px)', boxShadow: 2 },
                                                    }}
                                                >
                                                    <Box sx={{ p: { xs: 1.5, sm: 2 }, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                        <Box sx={{ color: Colors.primary, display: 'flex', flexShrink: 0 }}>{action.icon}</Box>
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: Colors.primary }}>
                                                                {action.title}
                                                            </Typography>
                                                            <Typography variant="caption" sx={{ color: 'text.secondary', display: { xs: 'none', sm: 'block' } }}>
                                                                {action.description}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            ) : (
                                /* ── Default landing (other roles) ── */
                                <Box sx={{ bgcolor: 'background.default', minHeight: '100%', py: 3, px: 2, display: 'flex', flexDirection: 'column' }}>
                                    <Container maxWidth="lg" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <HeroSection sx={{ textAlign: 'center' }}>
                                            <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <ImageContainer>
                                                    <LogoImage src="/images/nutrion_logo_circular.png" alt="Nutrion Logo" style={{ margin: '0 auto' }} />
                                                </ImageContainer>
                                                <Typography variant="h5" color="text.primary" sx={{ mb: 4, fontWeight: 'bold', textAlign: 'center', width: '100%' }}>
                                                    Producto Terminado
                                                </Typography>
                                            </Container>
                                        </HeroSection>
                                        <Grid container spacing={3} justifyContent="center" sx={{ flex: 1, pb: 6 }}>
                                            {getRoleSpecificActions().map((action, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                    <ActionCard>
                                                        <CardActionArea onClick={action.action} sx={{ height: '100%', p: 2 }}>
                                                            <CardContent sx={{ textAlign: 'center', p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                                                <CardIcon>{action.icon}</CardIcon>
                                                                <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 600, mb: 0.5 }}>
                                                                    {action.title}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                                                                    {action.description}
                                                                </Typography>
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </ActionCard>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Container>
                                </Box>
                            )}
                        </Grid>
                    )}
                </Grid>
            </Box>
        }  

       </React.Fragment>
  );
}